import * as addressesActions from '../actions/addresses';
import * as fetchingState from '../constants/fetchingState';
import { getErrorMessage } from '../constants/errorCode';

export default function(state, action) {
    switch (action.type) {
        case addressesActions.FETCH_ADDRESSES:
            {
                return {...state, fetching: fetchingState.FETCHING, addresses: [], error: undefined }
            }
        case addressesActions.SUCCESS_FETCH_ADDRESSES:
            {
                if (!action.data.error)
                    return {...state, fetching: fetchingState.FETCHED, addresses: action.data, addressesName: action.data.map(a => a.Address), error: undefined }
                return {...state, fetching: fetchingState.FETCHED, addresses: [], error: getErrorMessage(action.data.error) }
            }
        case addressesActions.FAILURE_FETCH_ADDRESSES:
            {
                return {...state, fetching: fetchingState.FAILED, addresses: [], error: getErrorMessage(action.data.error) }
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/addressesReducer.js